import styled from 'styled-components';

const Button = styled.button.attrs(({type}) => ({
    type: type || 'button'
}))`
  border: none;
  outline: none;
  cursor: pointer;
`;

const Form = styled.form.attrs(({method}) => ({
    method: method || 'post'
}))`
`;

const Input = styled.input.attrs(({type}) => ({
    type: type || 'text'
}))`
`;

const Link = styled.a`
    text-decoration: none;
    outline: none;
`;

const List = styled.ul`
  padding: 0;
  list-style: none;
  & > li{}
`;

const NotLogged = styled.div`
    font-size: 1.5rem;
    color: #fff;
    display: flex;
    justify-content: center;
    margin: 2rem 1rem;
`;

const Card = styled.div`
    background-color:#fff;
    display: flex;
    width:100%;
    height:100%;
    border-radius: 10px;
`;

export {Button, Form, Input, List, Link, NotLogged, Card};